import React, { Component } from 'react';
import { Link } from "react-router-dom";
class Team extends Component {
	constructor(props) {
        super(props);
        this.state = {
            menutab: [
                {
                    id: 1,
					title: 'Overview',
                    class: 'active',
                    url: '/about-v1'
                },
                {
                    id: 2,
                    title: 'Vision & Mission',
                    url: '/about-vision'
                },

            ],
            titletab: [
                {
                    id: 1,
                    title: 'Our Brochure',
                    description: 'View our Latest financial prospectus brochure for an easy to read guide on our portfolio.'
                }
            ]
        }
    }
    render() {
        return (
			<div className="col-md-3">
                <div className="sidebar left">
                    <aside className="widget widget_nav_menu">
                        <div className="menu-services-container">
                            <ul className="menu menu-tab">
                                {
                                    this.state.menutab.map(data =>(
                                        <li className={data.class} key={data.id} ><Link to={data.url}>{data.title}</Link></li>
                                    ))
                                }										
                            </ul>
                        </div>
                    </aside>

                    <aside className="widget widget-brochure services">
                        {
                            this.state.titletab.map(data =>(
                                <div className="brochure-box-title" key={data.id} >
                                    <h5 className="brochure-title">{data.title}</h5>
                                    <p> {data.description}</p>
                                </div>
                            ))
                        }			
                        <p className="btn-download">
                            <Link to="/resources/SUMRY_PROFILE_2022.pdf" title="" className="pdf" target="_blank" download>Download .PDF</Link>
                        </p>
                        <p className="btn-download doc">
                            <Link to="/resources/SUMRY_PROFILE_2022.docx" title="" className="doc" target="_blank" download>Download .DOC</Link>
                        </p>
                    </aside>
                </div>
            </div>
        )
                                
    }
}

export default Team;